import React from 'react';
import './style.scss';
import Button from '../../../components/controls/button';
import Dialog from '../../../components/general/dialog';

interface Props {
  opened: boolean;
  onClose: () => any;
}

const NotEnoughCreamDialog = ({ opened, onClose }: Props) => (
  <Dialog
    onClose={onClose}
    opened={opened}
    maxWidth='sm'
    fullWidth
    centered
    className='not-enough-cream-dialog'
  >
    <h2 className='necd-header body-1'>Not enough cream!</h2>
    <div className='necd-buttons'>
      <Button link='/creamshop/buy' fullWidth onClick={onClose}>
        Get Some Cream
      </Button>
    </div>
  </Dialog>
);

export default NotEnoughCreamDialog;
